import React from 'react';
import { Header } from '../components/layout/Header';
import { Footer } from '../components/layout/Footer';
import { siteConfig } from '../data/mock';

export default function TermsPage() {
  return (
    <div className="min-h-screen bg-black">
      <Header />
      <main className="pt-20">
        <div className="max-w-4xl mx-auto px-6 lg:px-12 py-24">
          <h1 className="text-3xl md:text-4xl font-semibold text-white mb-8">
            Terms of Service
          </h1>
          
          <div className="prose prose-invert max-w-none space-y-8 text-white/70">
            <p className="text-lg">
              Last updated: {new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}
            </p>

            <section className="space-y-4">
              <h2 className="text-xl font-semibold text-white">1. Acceptance of Terms</h2>
              <p>
                By accessing or using {siteConfig.name}, you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-xl font-semibold text-white">2. Description of Service</h2>
              <p>
                {siteConfig.name} provides a platform for secure documentation, organization, and report generation. Our service is intended for personal record-keeping purposes only.
              </p>
              <p className="font-medium text-white/90">
                Important: {siteConfig.name} is not a legal service and does not provide legal advice. Reports generated are for personal documentation purposes only.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-xl font-semibold text-white">3. User Accounts</h2>
              <p>
                You are responsible for:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Maintaining the confidentiality of your account credentials</li>
                <li>All activities that occur under your account</li>
                <li>Notifying us immediately of any unauthorized use</li>
              </ul>
            </section>

            <section className="space-y-4">
              <h2 className="text-xl font-semibold text-white">4. Acceptable Use</h2>
              <p>
                You agree not to use our service to:
              </p>
              <ul className="list-disc list-inside space-y-2 ml-4">
                <li>Violate any applicable laws or regulations</li>
                <li>Upload content that infringes on others&apos; rights</li>
                <li>Attempt to gain unauthorized access to our systems</li>
                <li>Interfere with the proper functioning of the service</li>
              </ul>
            </section>

            <section className="space-y-4">
              <h2 className="text-xl font-semibold text-white">5. Intellectual Property</h2>
              <p>
                You retain ownership of all content you upload. By using our service, you grant us a limited license to store, process, and display your content solely for the purpose of providing our services to you.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-xl font-semibold text-white">6. Limitation of Liability</h2>
              <p>
                To the maximum extent permitted by law, {siteConfig.name} shall not be liable for any indirect, incidental, special, consequential, or punitive damages resulting from your use of our service.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-xl font-semibold text-white">7. Termination</h2>
              <p>
                We reserve the right to suspend or terminate your account at any time for violation of these terms. You may terminate your account at any time through your account settings.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-xl font-semibold text-white">8. Changes to Terms</h2>
              <p>
                We may modify these terms at any time. We will notify you of material changes via email or through our service. Continued use after changes constitutes acceptance.
              </p>
            </section>

            <section className="space-y-4">
              <h2 className="text-xl font-semibold text-white">9. Contact</h2>
              <p>
                For questions about these Terms of Service, contact us at:
              </p>
              <p className="text-[#C9A962]">{siteConfig.supportEmail}</p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
